import { Tag } from "antd";

export const KakaoTag = () => {
  return (
    <Tag
      color="#FEE500"
      className="flex justify-center gap-2 m-1 w-[75px] text-[#191919] font-bold"
    >
      Kakao
    </Tag>
  );
};
